import SchemaItems from './schema-items';
export default {
  name: 'SchemaManager',
  components: {
    SchemaItems
  },
  props: {
    value: Boolean,
    schemas: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    name: '',
    isFixed: false
  }),
  computed: {
    fixedSchemas() {
      return this.schemas.filter(item => item.isFixed);
    },

    otherSchemas() {
      return this.schemas.filter(item => !item.isFixed);
    }

  },
  methods: {
    handleClose() {
      this.$emit('input', false);
    },

    handleSave(item) {
      // 编辑单个方案
      this.$emit('save', item);
    },

    handleDel(item) {
      this.$emit('del', item);
    }

  }
};